import React, { useState, useEffect, useContext } from 'react'
import { Modal } from 'react-bootstrap'
import { indicadoresNormasContext } from '../../IndicadoresNormas/IndicadoresNormas'
import { NormasContext } from '../../../context/NormasContext'
import "./ModalNewIndicador.scss"

function ModalEditIndicador(props) {

    const { user, idProyecto, objSeleccionado, setObjSeleccionado } = useContext(indicadoresNormasContext)
    const { fetchIndicadoresNormas } = useContext(NormasContext)

    const [userDatos, setUserDatos] = useState({
        nombre: "",
        descripcion: "",
        frecuencia: "",
        responsable: "",
        suplente: ""
    })

    const [errores, setErrores] = useState({})
    const [modalErr, setModalErr] = useState(null)

    useEffect(()=>{
        if(objSeleccionado){
            const obj = JSON.parse(objSeleccionado)
            setUserDatos({
                nombre: obj?.nombre_indicador,
                descripcion: obj?.detalles_metrica,
                frecuencia: obj.tipo_recordartorio.toString(),
                responsable: obj?.Empleados[0].mail,
                suplente: obj?.Empleados[1].mail
            })
        }
    },[objSeleccionado])

    const validateFormDatos = (data) => {
        const errors = {}
        if(!data.nombre.trim()) {
            errors.nombre = "Escriba un nombre para el indicador."
        }
        if(!data.descripcion.trim()) {
            errors.descripcion = "Escriba un texto para la descripcion."
        }
        if(!data.frecuencia.trim()) {
            errors.frecuencia = "Elija una frecuencia."
        }
        if(data.responsable === data.suplente){
            errors.responsable = "No puede ser el mismo mail."
            errors.suplente = "No puede ser el mismo mail."
        } else {
            if(!data.responsable.trim()) {
                errors.responsable = "Escriba el mail."
            } else if (!/\S+@\S+\.\S+/.test(data.responsable)){
                errors.responsable = "El email no es válido."
            }
            if(!data.suplente.trim()) {
                errors.suplente = "Escriba el mail."
            } else if (!/\S+@\S+\.\S+/.test(data.suplente)){
                errors.suplente = "El email no es válido."
            }
        }
        return errors;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDatos({
            ...userDatos,
            [name]: value,
        })
    }

    const handleClose = () => {
        props.onHide()
        setErrores({})
        setModalErr(null)
        setUserDatos({
            nombre: "",
            descripcion: "",
            frecuencia: "",
            responsable: "",
            suplente: ""
        })
        setObjSeleccionado(null)
    }

    const handleChangeIndicador = async (e) => {
        e.preventDefault()
        const obj = JSON.parse(objSeleccionado)
        const newErrors = validateFormDatos(userDatos);
        setErrores(newErrors)
        if(Object.keys(newErrors).length === 0) {
            const bodyEditInd = {
                user,
                indicador: obj,
                responsable: userDatos.responsable,
                nombre_indicador: userDatos.nombre,
                detalles_metrica: userDatos.descripcion,
                tipo_recordartorio: parseInt(userDatos.frecuencia),
                empleadoSuplente: userDatos.suplente
            }
            try {
                // EDIT INDICADOR PARA NORMAS ISO
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/editIndicador`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(bodyEditInd)
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status;
                if(errorCode !== 0){
                    setModalErr(data.errorDetalle || data.codeError)
                } else {
                    handleClose()
                    // actualizar indicadores
                    fetchIndicadoresNormas({
                        user,
                        opcion: 2,
                        idVista: parseInt(idProyecto)
                    })
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__editIndicador'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>Modificar Indicador</h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleChangeIndicador} className='form__editarIndicador w-100 d-flex flex-column align-items-center'>
                    {/* Nombre del indicador */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-2'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Nombre del indicador</label>
                        <div className='d-flex flex-column col-12 col-md-9'>
                            <input
                                autoFocus
                                onChange={handleChange}
                                type="text"  
                                name="nombre" 
                                className="form-control form-control-sm"
                                value={userDatos.nombre}
                            />
                            {errores.nombre && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.nombre}</span>}
                        </div>
                    </div>
                    {/* Descripción del indicador */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-2'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Descripción del indicador</label>
                        <div className='d-flex flex-column col-12 col-md-9'>
                            <input
                                onChange={handleChange}
                                type="text"  
                                name="descripcion" 
                                className="form-control form-control-sm"
                                value={userDatos.descripcion}
                            />
                            {errores.descripcion && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.descripcion}</span>}
                        </div>
                    </div>
                    {/* Frecuencia de carga */}
                    <div className="w-100 d-flex flex-column flex-md-row align-items-center mb-2">
                        <label className='me-1 col-12 col-md-3 col-form-label'>Frecuencia</label>
                        <div className='d-flex flex-column col-12 col-md-3'>
                            <select 
                                className="form-select form-select-sm" 
                                name="frecuencia" 
                                onChange={handleChange} 
                                value={userDatos.frecuencia}
                            >
                                <option value="">Elija la frecuencia</option>
                                <option value="1">Semanal</option>
                                <option value="2">Quincenal</option>
                                <option value="3">Mensual</option>
                                <option value="4">Trimestral</option>
                            </select>
                            {errores.frecuencia && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.frecuencia}</span>}
                        </div>
                    </div>
                    {/* Email del responsable */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-2'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Responsable</label>
                        <div className='d-flex flex-column col-12 col-md-9'>
                            <input
                                onChange={handleChange}
                                type="email"  
                                name="responsable" 
                                placeholder="usuario@correo.com.ar"
                                className="form-control form-control-sm"
                                value={userDatos.responsable}
                            />
                            {errores.responsable && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.responsable}</span>}
                        </div>
                    </div>
                    {/* Email del suplente */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-4'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Responsable suplente</label>
                        <div className='d-flex flex-column col-12 col-md-9'>
                            <input
                                onChange={handleChange}
                                type="email"  
                                name="suplente" 
                                placeholder="usuario@correo.com.ar"
                                className="form-control form-control-sm"
                                value={userDatos.suplente}
                            />
                            {errores.suplente && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.suplente}</span>}
                        </div>
                    </div>
                    {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                    <button type="submit" className='btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'>
                        Modificar Indicador
                    </button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalEditIndicador